import {cssTheme} from '@yandex-delivery/blocks';
import {css} from '@yandex-delivery/blocks/theme/css'
import {hex2rgba, spacing} from '@yandex-delivery/blocks/theme/theme'

const root = css`
  position: relative;
`

export const dropdownClasses = {
  root,
  dropdown: css`
    display: none;
    position: absolute;
    inset-block-start: ${spacing(2.25)};
    inset-inline-start: ${spacing(-2)};
    z-index: 1;
    .${root}:hover & {
      display: block;
    }
  `,
  icon: css`
    transition: all 0.25s ease-out;

    .${root}:hover & {
      transform: rotate(-180deg);
    }
  `,
  dropdownContent: css`
    margin-block-start: ${spacing(2.5)};
    padding: ${spacing(0.75, 2, 0.75, 2)};
    border-radius: ${spacing(1.875)};
    overflow: hidden;
    inline-size: max-content;
    background: ${hex2rgba(cssTheme.default.day.everBlack.hex, 0.7)};
    backdrop-filter: blur(${spacing(3.125)});
  `,
}
